import React, { useCallback, useEffect, useState } from 'react';
import { View, Text, StyleSheet, ActivityIndicator } from 'react-native';
import Icon from 'react-native-vector-icons/AntDesign';
import { Header } from 'react-native-elements';
import { useDispatch, useSelector } from 'react-redux';
import AsyncStorage from '@react-native-async-storage/async-storage';

import DynamicForm from '../../components/FormField/DynamicForm';
import { submitContestApi } from '../../api/adserver';
import { selectCurrentUser, setLoading } from '../../store/appSlice';
import { PROPERTY_ID, UNIT_ID } from '../../lib/constants';
import { RootState } from '../../store/rootReducer';
import { getContest, selectContest } from '../../store/contestSlice';
import { Alert } from 'react-native';

const styles = StyleSheet.create({
  container: {
    backgroundColor: 'white',
    flex: 1,
  },
  center: {
    height: '100%',
    justifyContent: 'center',
    alignSelf: 'center',
  },
});

function ContestLoadingState({
  contestData,
  contestLoaded,
  errorMessage,
}: {
  contestData: any;
  contestLoaded: boolean;
  errorMessage: string | null;
}) {
  if (contestData) {
    return null;
  }
  if (errorMessage || contestLoaded) {
    return (
      <View style={styles.center}>
        <Text>No contest available</Text>
      </View>
    );
  }
  return (
    <View style={styles.center}>
      <ActivityIndicator />
    </View>
  );
}

const ContestDynamicForm = ({ navigation }: any) => {
  const dispatch = useDispatch();
  const {
    loading,
    isSucess: contestLoaded,
    errMsg,
    data: contestData,
  } = useSelector((state) => selectContest(state as RootState));

  console.log(`${loading}, ${contestLoaded}, ${errMsg}, ${contestData}`);

  const { corpName } = useSelector((state) =>
    selectCurrentUser(state as RootState),
  );

  useEffect(() => {
    if (corpName) {
      dispatch(getContest(corpName));
    }
  }, [dispatch, corpName]);

  const onSubmit = useCallback(
    async (values) => {
      try {
        dispatch(setLoading({ isLoading: true }));
        const unitId = await AsyncStorage.getItem(UNIT_ID);
        const propertyId = await AsyncStorage.getItem(PROPERTY_ID);
        const res = await submitContestApi({
          contestId: contestData?.id,
          contestData: JSON.stringify(values),
          appId: '1',
          propertyId,
          unitId,
        });
        dispatch(setLoading({ isLoading: false }));
        Alert.alert(
          'Contest',
          'Thank you - You entry was recieved.',
          [
            {
              text: 'OK',
              onPress: () => {
                navigation.goBack();
              },
            },
          ],
          { cancelable: true },
        );
      } catch (error) {
        dispatch(setLoading({ isLoading: false }));
        Alert.alert(
          'Contest Error',
          'Sorry, there was an error when submitting your entry.  Please try again shortly.',
          [
            {
              text: 'OK',
              onPress: () => {},
            },
          ],
          { cancelable: true },
        );
      }
    },
    [dispatch, contestData, navigation],
  );

  const onGoBack = useCallback(() => navigation.goBack(), [navigation]);

  return (
    <View style={styles.container}>
      <Header
        backgroundColor={'#FFF'}
        leftComponent={
          <Icon color="#000" onPress={onGoBack} name="left" size={20} />
        }
        centerComponent={<Text>Contest</Text>}
      />
      {contestLoaded && contestData && (
        <DynamicForm initialValues={{}} onSubmit={onSubmit} {...contestData} />
      )}
      <ContestLoadingState
        contestLoaded={contestLoaded}
        contestData={contestData}
        errorMessage={errMsg}
      />
    </View>
  );
};

export default ContestDynamicForm;
